import { graphql, Link, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"
import { Col, Container, Row } from "react-bootstrap"

const query = graphql`
  {
    allStrapiBlogs(
      filter: { isPopular: { eq: true } }
      limit: 3
      sort: { fields: published_at, order: DESC }
    ) {
      nodes {
        id
        slug
        category
        title
        Image {
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED)
            }
          }
        }
      }
    }
  }
`

const PopularPosts = () => {
  const data = useStaticQuery(query)
  const {
    allStrapiBlogs: { nodes: popularPosts },
  } = data

  return (
    <Container className="popular-posts my-5">
      {popularPosts ? (
        <>
          <div className="d-flex mb-4 justify-content-start justify-content-lg-between align-items-center">
            <h1 className="rb b-h">Popular Posts</h1>
          </div>
          <Row>
            {popularPosts.map(item => {
              const path = getImage(item.Image.localFile)
              return (
                <Col lg={4} md={6} xs={6} key={item.id} className="p-items">
                  <Link to={`/blog/${item.category}/${item.slug}`}>
                    <GatsbyImage image={path} alt={item.title} />
                  </Link>
                  <Link to={`/blog/${item.category}`}>
                    <p className="my-2 cat">{item.category}</p>
                  </Link>
                  <Link to={`/blog/${item.category}/${item.slug}`}>
                    <h1 className="rb">{item.title}</h1>
                  </Link>
                </Col>
              )
            })}
          </Row>
        </>
      ) : (
        <h1 className="text-center">No Popular Posts</h1>
      )}
    </Container>
  )
}

export default PopularPosts
